export enum enumOrganizationRole {
  VIEWER = 0,
  READ = 1,
  WRITE = 2,
  DELETE = 4,
  CONTRIBUTER = 7,
  MANAGE = 8,
  ADMIN = 15,
}
